import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "space-x-1" }
const _hoisted_3 = { class: "font-semibold text-white JungleAdventurer text-base" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-white text-xs" }, "(Monster Galaxy)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "space-x-2" }, null, -1)
const _hoisted_6 = { class: "grid grid-cols-5 gap-2 mt-4" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "flex justify-center items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoData = _resolveComponent("NoData")!
  const _component_a_card = _resolveComponent("a-card")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createBlock(_component_a_card, {
    loading: _ctx.loading,
    class: "nft-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.title), 1),
          _hoisted_4
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            key: item.itemId,
            class: "item-border border rounded"
          }, [
            _withDirectives(_createElementVNode("img", {
              class: "nft-img w-16 h-16 cursor-pointer",
              onClick: ($event: any) => (_ctx.handleClick(item))
            }, null, 8, _hoisted_7), [
              [_directive_lazy, _ctx.logoUrlMapping.get(item.itemId)]
            ])
          ])), [
            [_vShow, _ctx.list?.length > 0]
          ])
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createVNode(_component_NoData, null, null, 512), [
          [_vShow, _ctx.list?.length == 0]
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}